import { Action } from "re-reduced";
import { SagaIterator } from "redux-saga";
import { call, race, take } from "redux-saga/effects";

import { TicketScanType } from "@graphql/sdk";
import actions from "@state/actions";
import { InitialScanPayload } from "@state/types";
import scanTicketOnline from "./scanTicketOnline";

const parseTicketNumber = (ticketNumber: string) => {
  return {
    ticketNumber: ticketNumber.replace("-1", ""),
    scanType: ticketNumber.includes("-1")
      ? TicketScanType.Hardcopy
      : TicketScanType.Digital,
  };
};
export default function* scanTicket(
  action: Action<InitialScanPayload>
): SagaIterator {
  const { ticketNumber, direction, bypassValidations } = action.payload;

  yield race({
    result: call(
      scanTicketOnline,
      actions.scanTicketOnline({
        ...parseTicketNumber(ticketNumber),
        direction,
        bypassValidations,
      })
    ),
    loggedOut: take([actions.logout.type, actions.clearState.type]),
  });
}
